import { Injectable } from '@angular/core';
import { SuiModalService } from '@giomamaladze/ng2-semantic-ui';
import { ConfirmModal } from '../confirm-modal/confirm-modal.component';
import { ConfirmModalSettings } from '@api-ui-app/src/app/shared/lib/confirm-modal-settings';
import { ConfirmDialogComponent } from '@gelato-api-ui/sdk/src/lib/shared/confirm-dialog/confirm-dialog.component';
import { DialogService } from '@gelato-api-ui/sdk/src/lib/shared/dialog/dialog.service';

@Injectable()
export class ConfirmModalService {
  constructor(private readonly modalService: SuiModalService, private readonly dialogService: DialogService) {}

  openDialog(settings: ConfirmModalSettings) {
    return this.dialogService.open(ConfirmDialogComponent, {
      data: { ...settings },
    });
  }

  /*
   * WARNING: this method is deprecated, use openDialog instead
   *          will be removed after all places are migrated
   * */
  open(settings: ConfirmModalSettings) {
    return this.modalService.open(new ConfirmModal(settings));
  }
}
